// auth/authUtils.js
import { DataService } from './DataService';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AppConfig } from '../../app/AppConfig';

export const useRoleCheck = (pageKey, isSubPage = false) => {
  const navigate = useNavigate();

  useEffect(() => {
    const userRoles = DataService.getUserRoles();
    const pageConfig = isSubPage
      ? AppConfig.homeSubPages.find((page) => page.url === pageKey)
      : AppConfig.pages.find((page) => page.url === pageKey);

    if (!pageConfig) {
      console.error(`Page config for key ${pageKey} not found`);
      navigate('/'); // Redirect to home or an error page
      return;
    }

    const requiredRoles = pageConfig.auth || [];
    const hasAccess = requiredRoles.some((role) => userRoles.includes(role));

    if (!hasAccess) {
      navigate('/'); // Redirect to home or an unauthorized page
    }
  }, [navigate, pageKey, isSubPage]);
};
